import React from 'react';
import { motion } from 'framer-motion';
const destinations = [{
  id: 'bonaire',
  title: 'BONAIRE',
  image: 'https://cdn.magicpatterns.com/uploads/1SoEkKy7Uwp4K6rH8ez82P/WhatsApp_Image_2026-06-12_at_04.26.42_(1).jpg',
  href: 'https://bonaire.buceoynavegacion.com/'
}, {
  id: 'noronha',
  title: 'FERNANDO DE NORONHA',
  image: 'https://cdn.magicpatterns.com/uploads/qhbcwrx5MSg1ghmYE6GcMz/WhatsApp_Image_2026-06-12_at_04.26.42.jpg',
  href: 'https://fernandodenoronha2026.buceoynavegacion.com/'
}];
export function Destinations() {
  return <section id="adventures" className="py-24 md:py-32 bg-zinc-950 text-white overflow-hidden" data-id="element-9">
      <div className="px-6 md:px-12 max-w-7xl mx-auto mb-12 md:mb-16" data-id="element-10">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-11">
          <span className="text-blue-400/80 font-mono text-[10px] md:text-xs uppercase tracking-[0.25em] block mb-4" data-id="element-12">
            Próximas Expediciones
          </span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold uppercase tracking-tight mb-6" data-id="element-13">
            Destinos Extraordinarios
          </h2>
          <p className="text-zinc-400 text-lg md:text-xl font-light max-w-2xl" data-id="element-14">
            "Algunos lugares no se visitan. Se viven."
          </p>
        </motion.div>
      </div>

      {/* Horizontal Swipe Carousel */}
      <div className="flex overflow-x-auto snap-x snap-mandatory gap-4 md:gap-6 px-6 md:px-12 pb-12 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]" data-id="element-15">
        {destinations.map((dest, i) => <motion.a key={dest.id} href={dest.href} target={dest.href.startsWith('http') ? '_blank' : undefined} rel={dest.href.startsWith('http') ? 'noopener noreferrer' : undefined} initial={{
        opacity: 0,
        x: 40
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.8,
        delay: i * 0.15,
        ease: 'easeOut'
      }} className="group relative block w-[85vw] sm:w-[60vw] md:w-[420px] lg:w-[480px] shrink-0 snap-start aspect-[4/5] rounded-2xl md:rounded-3xl overflow-hidden bg-zinc-900 shadow-2xl" data-id="element-16">
            <img src={dest.image} alt={dest.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-1000 ease-out group-hover:scale-105" data-id="element-17" />
            {/* Dark gradient overlay for text legibility */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent transition-opacity duration-700 group-hover:opacity-90" data-id="element-18" />

            <div className="absolute inset-0 p-8 md:p-10 flex flex-col justify-end" data-id="element-19">
              <h3 className="text-3xl md:text-4xl font-heading font-bold uppercase text-white tracking-wide transform transition-transform duration-500 group-hover:-translate-y-2" data-id="element-20">
                {dest.title}
              </h3>
            </div>
          </motion.a>)}
        {/* Spacer to ensure the last card can be scrolled past with padding */}
        <div className="w-[1px] shrink-0" data-id="element-21" />
      </div>
    </section>;
}